
const getSiteFromDomain = (domain: string, language: string) => {
	
	// For local development or preprod QA, we use the language as the domain
	if (domain === 'localhost' || domain === 'migdal.travelfactory.fr') {
		// domain = language;
		domain = 'cse.travelski.com';
	}

	switch (domain) {
		case "nl-NL":
		case "nl_NL":
		case "nl.travelski.com":
		case "www.nl.travelski.com": {
			return 'www.nl.travelski.com';
		}
		case "uk-UK":
		case "uk_UK":
		case "uk.travelski.com":
		case "www.uk.travelski.com": {
			return 'www.uk.travelski.com';
		}
		case "cse.travelski.com": {
			return 'cse.travelski.com';
		}
		default: {
			return 'www.travelski.com';
		}
	}
};

export default getSiteFromDomain;
